import React from 'react';
import { MenuItem } from './MenuItem';

export const MainMenu = () => {
  return (
    <div className='min-height-screen pb-12'>
      <div className='relative h-[40vh] overflow-hidden flex items-center justify-center'>
        <div className='absolute inset-0 z-0'>
          <img
            alt='Dingo'
            src='/images/dingo-header.jpg'
            className='w-full h-full object-cover opacity-60 scale-110 hover:scale-100 transition-transform duration-1000'
          />
          <div className='absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent' />
        </div>

        <div className='relative z-10 text-center px-4'>
          <h1 className='text-5xl md:text-7xl font-bold tracking-tight text-white mb-2 drop-shadow-lg'>
            DINGO
          </h1>
          <div className='h-1 w-24 bg-amber-500 mx-auto rounded-full mb-4' />
          <p className='text-amber-200 uppercase tracking-[0.3em] text-sm font-semibold'>
            QR Menu
          </p>
        </div>
      </div>

      <div className='max-w-4xl mx-auto px-6 -mt-10 relative z-20'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-8'>
          <MenuItem imgSrc={'/images/yıyecek.png'} linkTo={'/ana-yemekler'} description={"Ana Yemekler"} />
          <MenuItem imgSrc={'/images/ıcecek.png'} linkTo={'/soguk-icecekler'} description={"Soğuk İçecekler"} />
          <MenuItem imgSrc={'/images/tost.png'} linkTo={'/tostlar'} description={"Tostlar & Dürümler"} />
          <MenuItem imgSrc={'/images/cay.png'} linkTo={'/sicak-icecekler'} description={"Sıcak İçecekler"} />
        </div>
      </div>

      <div className='mt-12 text-center text-slate-500 text-sm'>
        <p>© {new Date().getFullYear()} Dingo Restaurant. Her hakkı saklıdır.</p>
      </div>
    </div>
  )
}

